import { COMPONENT_VALUE_TYPES as types, JOBS_OPENINGS_STYLE } from 'shared/constants';

const propsSchema = [
  {
    key: 'team',
    label: 'Default Department',
    type: types.TEXT
  },
  {
    key: 'jobBoard',
    label: 'Job Board',
    type: types.OBJECT,
    children: [
      {
        key: 'url',
        label: 'Job Board URL',
        type: types.TEXT
      },
      {
        key: 'jobsUrl',
        label: 'Jobs API URL',
        type: types.TEXT
      },
    ]
  },
  {
    key: 'style',
    label: 'Style',
    type: types.ENUM,
    options: JOBS_OPENINGS_STYLE,
    default: JOBS_OPENINGS_STYLE[0],
  }
];

const defaultProps = {
  team: 'Automated Driving',
  jobBoard: {
    url: 'https://boards.greenhouse.io/faradayfuture',
    jobsUrl: 'https://boards-api.greenhouse.io/v1/boards/faradayfuture/jobs?content=true'
  }
};

export default {
  title: 'Job Openings',
  id: 'Jobs',
  propsSchema,
  defaultProps
};
